import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconArrowRightOutlineStyle0 = gravityIconIndividualCss;

const GravityIconArrowRightOutline = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '0332abc5441c0e09fa16ea995c2310465f5adf48', color: this.color, size: this.size }, h("svg", { key: '1271676041aa4e4eb99213d6c7a00a50e093f20b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'fcde828a2b7df90e494ca6e4dd5dec40ed1412c0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.45 10.38 9.62 4.56a.48.48 0 0 0-.7 0l-.36.35a.51.51 0 0 0 0 .71l5.12 5.12-5.12 5.11a.51.51 0 0 0 0 .71l.36.35a.48.48 0 0 0 .7 0l5.83-5.82a.51.51 0 0 0 0-.71Z", fill: "currentColor" }))));
    }
};
GravityIconArrowRightOutline.style = GravityIconArrowRightOutlineStyle0;

export { GravityIconArrowRightOutline as gravity_icon_arrow_right_outline };

//# sourceMappingURL=gravity-icon-arrow-right-outline.entry.js.map